module.exports = __webpack_public_path__ + "assets/img/Amsterdam-Cricket-Academy.801ea771.png";